import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./licenses.component.html?ngResource";
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import _ from 'lodash';
import format from 'date-fns/format';
import { utils, writeFile } from 'xlsx';
let LicensesComponent = class LicensesComponent {
    organization = {};
    licenseTypes = [];
    selectedLicenseDetails = [];
    onSave = new EventEmitter();
    onRowExpanded = new EventEmitter();
    qty;
    licenseTableVC = {};
    /** Stores original license values in case editing is cancelled */
    prevQty = 0;
    columns = ['code', 'name', 'qty', 'used'].map(field => ({ field, header: _.startCase(field) }));
    columnStyles = {
        actions: 'flex: 0 1 3rem',
        code: 'flex-basis: 10%',
        name: 'flex-basis: 55%',
        qty: 'flex-basis: 20%',
        used: 'flex-basis: 15%'
    };
    multiSortMeta = [
        { field: 'name', order: 1 },
        { field: 'qty', order: 1 }, // ? UX-hack to sort *desc* when *first* clicking col/sort header
    ];
    get sanitizedLicenses() {
        return this.licenseTypes.map(({ code: Code, name: Name, qty: Qty, used: Used }) => ({ Code, Name, Qty, Used }));
    }
    get exportFilename() {
        return `${this.organization.name} License Summary ${format(new Date(), 'MM-dd-yyyy')}`;
    }
    ngOnChanges({ organization }) {
        if (organization?.isFirstChange() === false) {
            _
                .keys(this.licenseTableVC.editingRowKeys)
                .map(id => this.onRowEditCancel({ id }));
        }
    }
    onRowEditInit({ id, qty }) {
        this.licenseTableVC.editingRowKeys[id] = true; // In case this was called from outside of editableRow
        _.keys(this.licenseTableVC.editingRowKeys)
            .map(_id => _.find(this.licenseTypes, { id: _id }))
            .forEach((license) => {
            if (!license || id === license.id) {
                return;
            }
            this.onRowEditCancel(license);
        });
        this.prevQty = qty;
        _.delay(() => this.qty?.input.nativeElement?.select(), 50);
    }
    onRowEditSave({ id: licenseType, qty }) {
        this.onSave.emit({ licenseType, qty });
    }
    onRowExpand({ data: license }) {
        this.onRowExpanded.emit(license);
    }
    onRowEditCancel(license) {
        license.qty = this.prevQty;
        this.licenseTableVC.cancelRowEdit(license);
    }
    /**
     * Hide form/input UI for given license row
     *
     * ! fires before onClick does
     * but will exit early if focus is lost due to a btn's click
     *
     * @param {object} license
     * @param {FocusEvent} [event]
     */
    onBlur(license, event) {
        // ? FocusEvent will not include relatedTarget unless target is a <button>*
        const shouldIgnoreBlur = Boolean(event?.relatedTarget);
        shouldIgnoreBlur || this.onRowEditCancel(license);
    }
    /**
     * Unfortunately, Prime doesn't support using both row & cell editing modes together:
     * Row mode exposes an API for programmatically triggering edit mode (eg edit icon)
     * Cell mode is a great UX -especially for hotkey power users- and feels like Excel but has no API for toggling
     * To overcome this, row mode is set on the table we reproduce cell mode UX
     * Our version works better anyway
     *
     * @param {KeyboardEvent} event
     * @param {object} license
     * @returns {undefined}
     */
    onKeypressEvent(event, license) {
        switch (event.key) {
            case 'Escape':
                this.onRowEditCancel(license);
                break;
            case 'Enter':
                this.onRowEditSave(license);
                // a [clever] workaround for prime's table api lacking a way to hide the <input>
                this.licenseTableVC.cancelRowEdit(license);
                break;
            case 'Tab': {
                event.preventDefault();
                // eslint-disable-next-line unicorn/prefer-spread -- TS mad about Symbol.iterator missing on NodeList
                const rows = Array.from(document.querySelectorAll('.l-row p-celleditor'));
                const targetIdx = _.findIndex(rows, node => node.childNodes.length === 6) + (event.shiftKey ? -1 : 1);
                const nextRow = targetIdx >= rows.length ?
                    _.first(rows) :
                    targetIdx < 0 ?
                        _.last(rows) :
                        rows[targetIdx];
                const BTN_IDX = 1;
                const button = nextRow?.children?.[BTN_IDX];
                button?.click();
                break;
            }
            default:
                break;
        }
    }
    exportExcel() {
        writeFile({
            Sheets: { data: utils.json_to_sheet(this.sanitizedLicenses) },
            SheetNames: ['data']
        }, `${this.exportFilename}.xlsx`, { bookType: 'xlsx', type: 'array' });
    }
    static propDecorators = {
        organization: [{ type: Input }],
        licenseTypes: [{ type: Input }],
        selectedLicenseDetails: [{ type: Input }],
        onSave: [{ type: Output }],
        onRowExpanded: [{ type: Output }],
        qty: [{ type: ViewChild, args: ['qty',] }],
        licenseTableVC: [{ type: ViewChild, args: ['licenseTable',] }]
    };
};
LicensesComponent = __decorate([
    Component({
        selector: 'licenses',
        template: __NG_CLI_RESOURCE__0,
    })
], LicensesComponent);
export { LicensesComponent };
